import React, {useState, useEffect} from "react";
import { useNavigate, useSearchParams} from "react-router-dom";
import { FirstLogin } from "../../client/users";
import ModalSuccess from "../../components/shared/modals/modalSuccess";
import { BACKGROUND_IMAGES } from "../../config/images";
export default function CreatePassword() {
    const [searchParams] = useSearchParams();
    const token = searchParams.get("token");
    const navigate = useNavigate();
    
    const [newPassword, setNewPassword] = useState("");
    const [passwordError, setPasswordError] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [isSubmitAttempted, setIsSubmitAttempted] = useState(false);
    const [showSuccessModal, setShowSuccessModal] = useState(false);


    useEffect(() => {
        if (!token) {
            navigate("/");
        }
    }, [token, navigate]);

    const closeSuccessModal = () => {
        setShowSuccessModal(false);
        navigate("/"); 
    };

    const validatePassword = (password) => {
        if (password.length < 6 || password.length > 15) {
            return "La contraseña debe tener entre 6 y 15 caracteres.";
        }

        const hasNumber = /[0-9]+/;
        const hasUpperChar = /[A-Z]+/;
        const hasLowerChar = /[a-z]+/;

        if (!hasLowerChar.test(password)) {
            return "La contraseña debe contener al menos una letra minúscula.";
        }

        if (!hasUpperChar.test(password)) {
            return "La contraseña debe contener al menos una letra mayúscula.";
        }

        if (!hasNumber.test(password)) {
            return "La contraseña debe contener al menos un número.";
        }

        return "";
    };

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    const isPasswordValid = !validatePassword(newPassword);


    const handleUpdatePassword = async () => {
        setIsSubmitAttempted(true);
        const error = validatePassword(newPassword);
        if (error) {
            setPasswordError(error);
            return;
        }

        setIsLoading(true);
        try {
            await FirstLogin(token, { password: newPassword });
            setShowSuccessModal(true);
        } catch (error) {
            alert(error.response?.data?.message || "Error al actualizar la contraseña");
        } finally {
            setIsLoading(false);
        }
    };


    return (
        <div className="relative z-10 flex items-center justify-center w-full min-h-screen pt-10 pb-6 bg-center bg-cover bg-tasa">
            <img src={BACKGROUND_IMAGES.FIGURE_GREEN} alt="triangle-figure" className="absolute z-40 short:w-[8%]  w-[20%] bottom-[30%] sm:bottom-[40%] lg:w-[16%] lg:bottom-[10%] 2xl:bottom-[20%] left-0 "/>
            <img src={BACKGROUND_IMAGES.FIGURE_BLUE} alt="blue-figure" className="absolute z-20 short:w-[45%]  w-full lg:w-[60%] bottom-0 left-0 "/>
            <img src={BACKGROUND_IMAGES.FIGURE_LIGHT_BLUE} alt="lightblue-figure" className="absolute z-30 short:w-[42%] w-full lg:w-[50%] bottom-0 right-0 "/>
            <img src={BACKGROUND_IMAGES.LOGO} alt="logo-tasa" className="absolute z- short:w-[18%] w-[35%] lg:w-[12%] top-3 left-4 "/>
            <img src={BACKGROUND_IMAGES.LINES_GREEN} alt="lines-figure" className="absolute short:w-[8%] z-30 w-[20%] lg:w-[7%] top-3 right-0 "/>

            <div className="relative z-50 flex items-center justify-center w-full">
                <div className="flex flex-col items-center justify-center w-full gap-10 pt-5">
                    <div className="lg:w-[33%] md:w-[45%] w-[90%] h-auto bg-white rounded-3xl shadow-lg flex flex-col p-5 py-8 ">
                        <div className='flex flex-col justify-center gap-2 px-4 lg:px-8'>
                            <p className="text-left text-black font-itcbook">Escriba su nueva contraseña: <span className="text-red-500">*</span></p>
                            <div className="relative">
                                <input
                                    type={showPassword ? "text" : "password"}
                                    className='placeholder:font-itcbook w-full flex font-itcbook justify-center items-center outline-none placeholder:text-sm text-sm placeholder:text-[#6B7280] border-[1px] border-[#D1D5DB] rounded-md p-2'
                                    placeholder='Escriba su contraseña'
                                    value={newPassword}
                                    onChange={(e) => {
                                        setNewPassword(e.target.value);
                                        setPasswordError("");
                                    }}
                                />
                                {(!isPasswordValid && isSubmitAttempted) ? (
                                    <span className='absolute inset-y-0 flex items-center pointer-events-none text-red right-4'>
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm0-4h-2V7h2v8z" fill="currentColor"/>
                                        </svg>
                                    </span>
                                ) : (
                                    <span 
                                        className="absolute inset-y-0 flex items-center cursor-pointer right-4"
                                        onClick={togglePasswordVisibility}
                                    >
                                        {showPassword ? (
                                            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M8.99994 11.7474C7.48358 11.7474 6.25244 10.5163 6.25244 8.99994C6.25244 7.48358 7.48358 6.25244 8.99994 6.25244C10.5163 6.25244 11.7474 7.48358 11.7474 8.99994C11.7474 10.5163 10.5163 11.7474 8.99994 11.7474ZM8.99994 6.37744C7.5538 6.37744 6.37744 7.5538 6.37744 8.99994C6.37744 10.4461 7.5538 11.6224 8.99994 11.6224C10.4461 11.6224 11.6224 10.4461 11.6224 8.99994C11.6224 7.5538 10.4461 6.37744 8.99994 6.37744Z" stroke="#6B7280"/>
                                            <path d="M2.10894 10.981L2.10823 10.9799C1.77368 10.4591 1.59131 9.74477 1.59131 9.00292C1.59131 8.26141 1.77354 7.54474 2.10869 7.01963C3.87716 4.26251 6.39653 2.73511 9.00006 2.73511C11.6038 2.73511 14.1229 4.26268 15.8837 7.01926L15.8844 7.02036C16.2189 7.54111 16.4013 8.25545 16.4013 8.9973C16.4013 9.73901 16.219 10.4559 15.8836 10.981C14.1229 13.7376 11.6038 15.2651 9.00006 15.2651C6.38861 15.2651 3.86953 13.7373 2.10894 10.981ZM9.00006 2.86011C6.3643 2.86011 3.90504 4.44214 2.21875 7.08835C1.87235 7.62907 1.71818 8.33206 1.71818 9.00011C1.71818 9.66792 1.87224 10.3706 2.21838 10.9113C3.90468 13.5578 6.36411 15.1401 9.00006 15.1401C11.6358 15.1401 14.0951 13.5581 15.7814 10.9119C16.1278 10.3711 16.2819 9.66816 16.2819 9.00011C16.2819 8.33204 16.1278 7.62902 15.7813 7.08829C14.095 4.44212 11.6358 2.86011 9.00006 2.86011Z" stroke="#6B7280"/>
                                            </svg>
                                        ) : (
                                            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M2.25 7.5C2.89431 8.28073 3.65286 8.95964 4.5 9.51375M4.5 9.51375C5.41237 10.109 6.43096 10.5228 7.5 10.7325C8.49094 10.9229 9.50906 10.9229 10.5 10.7325C11.569 10.5228 12.5876 10.109 13.5 9.51375M4.5 9.51375L3.375 10.875M15.75 7.5C15.1057 8.28073 14.3471 8.95964 13.5 9.51375M13.5 9.51375L14.625 10.875M7.5 10.7318L7.125 12.375M10.5 10.7318L10.875 12.375" stroke="#6B7280" strokeLinecap="round" strokeLinejoin="round"/>
                                            </svg>
                                        )}
                                    </span>
                                )}
                            </div>
                            {passwordError && (
                                <p className='w-full text-xs text-left text-red font-itcbook'>
                                    {passwordError}
                                </p>
                            )}
                            <p className='text-[#6B7280] pl-2 text-[12px] font-itcbook'>
                                *La contraseña debe tener entre 6 y 15 caracteres, incluir al menos una letra mayúscula, 
                                una letra minúscula y un número.
                            </p>
                            <button 
                                onClick={handleUpdatePassword}
                                disabled={isLoading}
                                className='text-sm underline cursor-pointer text-blue font-itcbook'>
                                {isLoading ? "Procesando..." : "Aceptar"}
                            </button>       

                        </div>
                    </div>
                </div>
            </div>
            <ModalSuccess 
                showModalSuccess={showSuccessModal}
                closeModalSuccess={closeSuccessModal}
                fill="green"
                text="Contraseña creada correctamente. Ahora puedes iniciar sesión."
            />
        </div>        
    );
}